module.exports = __webpack_public_path__ + "static/media/Talon-Profile-cropped.eb570806.jpeg";